<template>
  <v-footer
    class="footer-container"
    padless
  >
    <v-card
      flat
      tile
      class="footer-card text-center"
    >
      <v-card-text class="footer-links">
        <a
          href="https://jciindia.in"
          target="_blank"
          class="footer-link"
        >
          JCI India
        </a>
        <span class="mx-3">|</span>
        <a
          href="http://vaagai.org.in"
          target="_blank"
          class="footer-link"
        >
          Powered by Vaagai Tecknowledge
        </a>
      </v-card-text>

      <v-divider />

      <v-card-text class="footer-info">
        <div class="copyright">
          &copy; {{ CurrentYear }} JCI India. All Rights Reserved.
        </div>
        <div class="version-info">
          App version {{ AppVersion }}
          <span
            v-if="VersionInfo"
            class="mx-2"
          >|</span>
          {{ VersionInfo }}
        </div>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import { version } from "/package.json";
import common from "@/Common.vue";
// import ScrollToTop from "@/components/ScrollToTop.vue";

export default {
  name: "KTFooter",
  components: {
    // ScrollToTop,
  },
  mixins: [common],
  data() {
    return {
      AppVersion: version,
      VersionInfo: "",
      CurrentYear: new Date().getFullYear(),
    };
  },
  beforeMount() {
    console.log("beforeMount called");
    var url2 = "api/pages/version-info";
    var condition2 = {
      UserInterface: 9,
    };
    this.getPageDetails("VersionInfo", "", url2, condition2);
  },
};
</script>
<style scoped>
.footer-container {
  --aqua: #0097d7;
  --navy: #3a67b1;
  --gold: #edbe38;
  --seafoam: #56bda3;
  --black-90: #414042;
}

.footer-card {
  width: 100%;
  background-color: var(--navy) !important;
  color: white !important;
}

.footer-links {
  padding: 16px 0;
}

.footer-link {
  color: white !important;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: var(--gold) !important;
}

.footer-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 16px 24px;
}

.copyright {
  color: rgba(255, 255, 255, 0.7);
}

.version-info {
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 768px) {
  .footer-info {
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
  .copyright {
    margin-bottom: 8px;
  }
}
</style>
